module.exports = __webpack_public_path__ + "static/word-mask.08ab6558.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-mask.png
// module id = 994
// module chunks = 2